import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import CountryApi from '../server/CountryApi';

function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}


const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);


export default {
    
    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.COUNTRY_LIST);
        const handleError = createErrorHandler(ActionTypes.COUNTRY_LIST_ERROR);

        return CountryApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    }

};
